module.exports = __webpack_public_path__ + "static/media/el-ateneo.ac577dcd.md";